export enum SportType {
  SKIING = "Skiing",
  SNOWBOARDING = "Snowboarding",
}